module.exports = __webpack_public_path__ + "img/benefits-17.71bb0325.svg";